jQuery(document).ready(function($) {

  // tab enter clicks for search and mobile menu
  $('.search-toggle, .mobile-menu-toggle').keypress(function(e) {
    if (e.which == 32 || e.which == 13) {
      $(this).trigger('click')
      e.preventDefault()
    }
  })

  // escape closes modal
  $(document).keydown(function(e){
    var code = e.keyCode || e.which
    if (code == 27) {
      if ($('body').hasClass('search-overlay--is-showing')) {
        $('.search-toggle').trigger('click')
      }
    }
  })

  // ignore svgs
  $('svg.svg-inline--fa').attr('alt', '').attr('aria-hidden', 'true').attr('tabindex', '-1')

})
